<template>
	<div>
		<div v-if="isUserAllowedInLevel2">
			<BaseHeader :title="$t('premium_lawyers_offices_lawyers')" />

			<div class="main">
				<div v-if="companies && companies.length" class="flex flex-col">
					<div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
						<div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
							<div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
								<table class="min-w-full divide-y divide-gray-200">
									<thead>
										<tr>
											<th
												v-for="header in headers"
												:key="header.name"
												:class="header.class"
												class="py-3 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider"
											>
												{{ header.name }}
											</th>
										</tr>
									</thead>

									<tbody class="bg-white divide-y divide-gray-200">
										<PremiumLawyerOfficeRow v-for="company in companies" :key="company.id" :value="company" />
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>

				<div v-else-if="!companies" class="flex flex-grow justify-center w-full opacity-75">
					<loader color="#343434" />
				</div>

				<div v-else>
					{{ $t('no_entries_found') }}
				</div>
			</div>
		</div>

		<div v-else>
			<Forbidden />
		</div>
	</div>
</template>

<script>
import loader from 'vue-spinner/src/PulseLoader.vue';
import BaseHeader from '@/components/navigation/BaseHeader';
import CompanyRow from '@/components/rows/CompanyRow';
import Forbidden from '@/views/default/Forbidden';
import Authentication from '@/mixins/Authentication';
import PremiumLawyerOfficeRepository from '@/api/repositories/PremiumLawyerOfficeRepository';
import PremiumLawyerOfficeRow from '@/views/premiumpartners/PremiumLawyerOfficeRow.vue';

export default {
	name: 'PremiumLawyerOfficesOverview',
	components: {
		PremiumLawyerOfficeRow,
		BaseHeader,
		CompanyRow,
		Forbidden,
		loader,
	},
	mixins: [Authentication],
	data() {
		return {
			companies: null,
			companyType: {
				title: this.$t('lawyers_offices_lawyers'),
				buttonText: this.$t('lawyers_office'),
			},
			headers: [
				{ name: 'Name', class: 'px-6' },
				{ name: 'Inhaber', class: 'px-6' },
			],
		};
	},
	created() {
		if (this.isUserAllowedInLevel2) {
			this.updateCompanies();
		}
	},
	methods: {
		updateCompanies() {
			new PremiumLawyerOfficeRepository().getPremiumLawyersOffices({ partner_type: 'premium_partner' }).then(response => {
				this.companies = response.data?.data || response.data;
			});
		},
	},
};
</script>
